__turbopack_context__.v({
  "teasers": "Teasers-module-scss-module__Exnshq__teasers",
});
